<div class="d-flex flex-column gap-1">
  <span *ngIf="showLabel" class="file-label">{{ fileLabel }}</span>
  <div class="d-flex file-container">
    <div class="selected-file" [class.disabled]="disabled" [class.error]="hasError">
      <div class="d-flex align-items-center gap-2 file-info">
        <div class="thumbnail" *ngIf="showThumbnailBox$ | async">
          <lib-loading-shimmer *ngIf="showThumbnailShimmer$ | async" [height]="'2.5rem'" [width]="'2.5rem'" />
          <img
            *ngIf="showThumbnailImage$ | async"
            class="thumbnail-image"
            [class.disabled]="disabled"
            [src]="thumbnailUrl$ | async"
            (error)="onThumbnailError()"
            alt="" />
          <img
            *ngIf="showThumbnailFallback$ | async"
            class="thumbnail-image thumbnail-fallback"
            [class.disabled]="disabled"
            [src]="thumbnailFallbackSrc"
            alt="Preview unavailable"
            i18n-alt />
        </div>
        <span class="file-name" [class.disabled]="disabled" [title]="fileName">
          <span class="file-name-base">{{ fileNameBase$ | async }}</span>
          <span class="file-name-extension">{{ fileNameExtension$ | async }}</span>
        </span>
      </div>
      <span class="file-size" [class.disabled]="disabled">{{ fileSizeString$ | async }}</span>
    </div>
    <div class="option-buttons">
      <button
        *ngIf="showPreview"
        type="button"
        class="no-style-button preview"
        [disabled]="disabled || !(previewAvailable$ | async)"
        (click)="onPreviewClick()"
        i18n>
        Preview
      </button>
      <button
        *ngIf="action === 'download'"
        type="button"
        class="no-style-button download"
        [disabled]="disabled || actionDisabled"
        (click)="onDownloadClick()"
        i18n>
        Download
      </button>
      <button
        *ngIf="action === 'remove'"
        type="button"
        class="no-style-button remove"
        [disabled]="disabled || actionDisabled"
        (click)="removeClicked.emit()"
        i18n>
        Remove
      </button>
    </div>
  </div>
</div>
